import React, { useState, useContext } from 'react';
import {VegaFlex, VegaText, VegaIcon, VegaButtonLink, VegaBox, VegaDivider} from "@heartlandone/vega-react";
import {ROUTES_PATH, MODULE, REGISERED_SUB_MENU, ACTIVITY_STATUS} from 'Chore/Constants';
import { useNavigate } from 'react-router-dom';
import { useNavigationHistory } from 'Navigation/NavigationHistoryProvider';
import defaultImage from "Components/ActivityListItem/assets/default-cover.png";
import './module.css';
import { HubContext } from 'Redux/Context/context';
import ActivityDetailAvatar from 'Components/ActivityDetailListItem/ActivityDetailAvatar';
import ViewFeedbackAction from 'Views/MyActivity/ActivityActions/ViewFeedback';
import ActivityCategory from "../../Views/MyActivity/ActivityInformations/Category";
import ActivityState from "../../Views/MyActivity/ActivityInformations/State";
import ActivityCharge from "../../Views/MyActivity/ActivityInformations/Charge";
import ActivityScore from "../../Views/MyActivity/ActivityInformations/Score";
import ActivityPendingFeedbackState from "../../Views/MyActivity/ActivityInformations/PendingFeedbackState";
import AddFeedbackAction from "../../Views/MyActivity/ActivityActions/AddFeedback";
import CancelRegistrationAction from "../../Views/MyActivity/ActivityActions/CancelRegistration";
import ActivityGuest from "../../Views/MyActivity/ActivityInformations/Guest";
import ActivityAddress from "../../Views/MyActivity/ActivityInformations/Address";
import ActivityTimeRange from "../../Views/MyActivity/ActivityInformations/TimeRange";
import ActivityTitle from "../../Views/MyActivity/ActivityInformations/Title";
const { MY_ACTIVITIES } = MODULE;
const { REGISTERED, ACTIVITY_DETAIL } = MY_ACTIVITIES;
function ActivityDetailListItem(props) {
  const { activity, module } = props;
  const { address, city, activityStatus,isOnlineActivity, chargeAmount=0, endTime, id, participantsCount=0, registerNumberLimit, registerNumberLimitType, startTime, title, hasFeedback, coverUrl, averageRating, showFeedback, isAllowInviteGuests } = activity;
    const navigate = useNavigate();
    useNavigationHistory();
  const [_hasFeedback, setHasFeedback] = useState(hasFeedback);
  const { myActivitiesState} = useContext(HubContext);
  const { subModule } = myActivitiesState;
  const { STATUS_LABEL } = ACTIVITY_STATUS;
  const _showCancelRegisterBtn = () => {
    return subModule === REGISERED_SUB_MENU.REGISTERED &&
        activityStatus !== STATUS_LABEL.CLOSED;
  }


  const _showAddFeedbackBtn = () => {
    return showFeedback && !_hasFeedback && subModule === REGISERED_SUB_MENU.PENDING_FEEDBACK;
  }
  const _onViewDetialClick = () => {
    if (module === REGISTERED) {
      navigate(`${ROUTES_PATH.MY_ACTIVITY_REGISTERED_DETAIL}/${id}`);
    } else if (module === ACTIVITY_DETAIL) {
      navigate(`${ROUTES_PATH.ACTIVITY_INFO}/${id}`);
    }
  }
  const isViewFeedbackAction = () => {
    return showFeedback && _hasFeedback && subModule === REGISERED_SUB_MENU.CLOSED;
  };
  const _showActivityDetailBtn = () => {
    return module === ACTIVITY_DETAIL;
  }

  const _showCategory = () => {
    if (activity?.publisherCategory === null || activity?.publisherCategory === "" || activity?.publisherCategory === undefined) {
      return false;
    }
    return true;
  }
  const _getHasFeedbackCallback = (hasFeedback) => setHasFeedback(hasFeedback);
  return (
    <VegaFlex className='p-24 round-12 activity-list-item-border ' justifyContent="space-between">
      <VegaFlex direction={'col'} gap={'size-12'}>
        <VegaFlex gap={'size-8'}>
          <VegaBox flexShrink="0">
            <ActivityState state={activityStatus} />
          </VegaBox>
          {!hasFeedback &&
              subModule === REGISERED_SUB_MENU.PENDING_FEEDBACK && (
                  <ActivityPendingFeedbackState />
              )}
          {
              _showCategory() &&
              <ActivityCategory category={activity?.publisherCategory} />
          }
          <ActivityCharge chargeAmount={chargeAmount} />
          {subModule === REGISERED_SUB_MENU.CLOSED && (
              <ActivityScore score={averageRating} />
          )}
        </VegaFlex>
        <ActivityTitle state={activityStatus} title={title} />
        <VegaFlex className='activity-detail-userinfo'>
            <ActivityDetailAvatar name={activity.createdBy} avatarUrl={activity.createdByAvatarUrl === null ? "" : activity.createdByAvatarUrl}></ActivityDetailAvatar>
          <span className='activity-detail-userinfo-name'>{activity.createdBy}</span>
        </VegaFlex>
        <ActivityTimeRange startTime={startTime} endTime={endTime} />
        <ActivityAddress
            online={isOnlineActivity}
            address={address}
            city={city}
        />
        <VegaFlex className='font-light-text-color-secondary'>
          <VegaIcon
            icon="fa-light fa-users-viewfinder"
            size="size-16"
          ></VegaIcon>
          <VegaText className="m-l-12 f-size-14 font-normal f-weight-400 line-height-16">Participants ({participantsCount}{ registerNumberLimitType === 'Limited' ? `/${registerNumberLimit}` : ''})</VegaText>
        </VegaFlex>
        <ActivityGuest isAllowInviteGuests={isAllowInviteGuests}></ActivityGuest>
        <VegaFlex className={"action-button"} gap={'size-12'}>
          {[
              _showActivityDetailBtn() &&
              <VegaButtonLink
                  label="View Activity Details"
                  icon="fa-regular fa-eye"
                  onVegaClick={() => _onViewDetialClick()}
              />,

            _showCancelRegisterBtn() &&
            <CancelRegistrationAction activity={activity} />,

            _showAddFeedbackBtn() &&
            <AddFeedbackAction
                activity={activity}
                onFeedbackSet={_getHasFeedbackCallback}
            />,

            isViewFeedbackAction() &&
            <ViewFeedbackAction activity={activity} />
          ].filter((button) => !!button)
              .map((button, index) => (
                  <React.Fragment key={index}>
                    {!!index && (
                        <VegaBox height="size-24">
                          <VegaDivider direction="vertical" />
                        </VegaBox>
                    )}
                    {button}
                  </React.Fragment>
              ))}
        </VegaFlex>
      </VegaFlex>
      <VegaFlex>
        <img src={ coverUrl || activity?.cover?.url || defaultImage} alt="" className='activity-detail-head-img round-12'/>
      </VegaFlex>
    </VegaFlex>
  );
}

export default ActivityDetailListItem;
